// extracted by mini-css-extract-plugin
export default {"wrapper":"account_wrapper__PGnU6","mobile":"account_mobile__4HIvA","tablet":"account_tablet__xGHtv"};